import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoints, spacing } from '../../../../utils/styleguide';
import Typography from '../../../component-library/text/Typography';
import { Asset } from 'contentful';

const Wrapper = styled.div<{ direction?: string }>`
  display: flex;
  flex-direction: column;
  padding: 40px 0;
  justify-content: space-between;
  ${({ direction }) => `
    ${breakpoints.desktop} {
      flex-direction: ${direction};
    }`}
`;

const SectionWrapper = styled.div`
  flex-basis: calc(50% - ${spacing[2]}px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${spacing[3]}px 0;
`;

const Image = styled.img`
  display: block;
  width: 100%;
  max-width: 400px;
  margin: auto;
`;

type Props = {
  header?: string;
  text?: string;
  image?: Asset;
  direction?: string;
};

const ResponsiveBlock = ({ header, text, image, direction }: Props) => {
  const hasImage = !!image;
  return (
    <Wrapper direction={direction}>
      <SectionWrapper>
        <Typography
          useBuiltInMargins
          variant="title"
          css={css`
            margin-bottom: 0;
          `}
        >
          {header}
        </Typography>
        <Typography useBuiltInMargins variant="body">
          {text}
        </Typography>
      </SectionWrapper>
      {hasImage && (
        <SectionWrapper>
          <Image alt={image?.fields.title} src={`https:${image?.fields.file.url}`} />
        </SectionWrapper>
      )}
    </Wrapper>
  );
};

export default ResponsiveBlock;
